let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("ffQaD"), load("kvRbA"), load("dAq7W")]).then(() => parcelRequire('1jMgA'));